import React, { Component } from 'react';

import { isMobile, isIOS } from 'react-device-detect';
import classes from './StepFour.module.css';
import strings from '../../../../../assets/localization';
import Button from '../../../../UI/Button/Button';
import Input from '../../../../UI/Input/Input';
import InputError from '../../../../UI/InputError/InputError';
import { gtmTrack } from '../../../../../assets/helpers/GAHelper';
import {
  validateUsername,
  checkUsernameForNumbersOnly,
} from '../../../../../assets/helpers/utils';

export default class StepFour extends Component {
  constructor(props) {
    super(props);
    this.textInput = React.createRef();
    this.state = {
      usernameError: '',
      username: '',
      isDirty: false,
    };
  }
  a;

  componentDidUpdate(prevProps) {
    // console.log('STEP 4 DID UPDATE:::', this.props);

    // Handle successful username check
    if (
      this.props.checkUsername.status === 'success' &&
      this.props.checkUsername.status !== prevProps.checkUsername.status
    ) {
      this.props.goToStep(5);
    }

    // Handle failed username check
    if (
      this.props.checkUsername.status === 'fail' &&
      this.props.checkUsername.status !== prevProps.checkUsername.status &&
      this.props.checkUsername.fromPage === 'StepFour-inner'
    ) {
      this.setState({ usernameError: this.props.checkUsername.error.error });
      gtmTrack({
        event: 'signup_error',
        message: this.props.checkUsername.error.error,
      });
    }

    // Update username state when props change
    if (prevProps.username !== this.props.username) {
      this.setState({ username: this.props.username });
    }
  }

  componentDidMount() {
    if (this.props.username === '') {
      this.textInput.focus();
    } else {
      this.setState({ username: this.props.username });
    }
  }

  _handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      this.props.setUsername(this.state.username);
      this._checkUsername();
      this._checkUsernameErrors(this.state.username);
    }
  };

  _onChange = (e) => {
    const {
      target: { value },
    } = e;
    // Remove any spaces from the input value
    const valueWithoutSpaces = value.replace(/\s/g, '');
    this.setState({ username: valueWithoutSpaces });

    if (valueWithoutSpaces.length >= 6 && !this.state.isDirty) {
      this.setState({ isDirty: true });
    }

    this._checkUsernameErrors(valueWithoutSpaces);
  };

  _checkUsername = () => {
    if (this._validateUsername()) {
      this.props.nbsApiCheckUsername(
        { username: this.state.username },
        'StepFour-inner'
      );
    }
  };

  _validateUsername = () => {
    const { username } = this.state;
    const { usernameError } = this.state;

    return validateUsername(username) && usernameError === '';
  };

  _checkUsernameErrors = (username) => {
    if (this.state.isDirty || username.length >= 6) {
      if (!validateUsername(username)) {
        this.setState({ usernameError: strings.lettersAndNumbersOnly });
      } else {
        if (checkUsernameForNumbersOnly(username)) {
          this.setState({ usernameError: strings.useAtLeastOneLetter });
        } else {
          this.setState({ usernameError: '' });
        }
      }
    }
  };

  _onNextClick = () => {
    this.props.setUsername(this.state.username);
    this._checkUsername();
  };

  render() {
    // console.log('STEP 4 RENDER:', this.state);

    const { hideHeader } = this.props;
    const { username } = this.state;
    let cssStyles = classes.StepFour;

    return (
      <div className={cssStyles}>
        <div className={classes.InputWrapper}>
          <Input
            setRef={(component) => {
              this.textInput = component;
            }}
            type='text'
            value={username}
            onChange={this._onChange}
            onKeyDown={this._handleKeyDown}
            label={`${strings.chooseUsername} ${strings.usernameLabelSmall}:`}
            inputLabelStyle={{
              fontSize: '0.8125rem',
              fontWeight: 'var(--font-weight-normal)',
              textAlign: 'left',
              paddingTop: '0',
              width: '100%',
              marginBottom: '0.5rem',
            }}
            placeholder={strings.usernamePlaceholder}
            maxLength={14}
            showRedTriangle={
              this.state.isDirty &&
              (!this._validateUsername() ||
                checkUsernameForNumbersOnly(this.state.username))
            }
          />
          <InputError
            style={{
              display: this.state.usernameError !== '' ? 'block' : 'none',
            }}
          >
            {this.state.usernameError}
          </InputError>
        </div>
        <div className={classes.Footer}>
          <Button
            disabled={
              !this._validateUsername() ||
              checkUsernameForNumbersOnly(this.state.username)
            }
            clicked={this._onNextClick}
          >
            {strings.next}
          </Button>
        </div>
      </div>
    );
  }
}
